// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'jsx' is declared but its value is never read.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { css, jsx } from "@emotion/react";
import * as React from "react";
import { connect } from "react-redux";

import { Last7DaysMode } from "constants/reports/last-7-days-mode";
import { ReportType } from "constants/reports/report-type";
import { EventPlace } from "helpers/analytics";
import { trackLast7DaysEmptyStateClicked, trackLast7DaysSummaryReportClicked } from "helpers/analytics-reports";
import { useLastVisitedReport } from "hooks/reports/use-last-visited-report";
import { ReportLocalTimeLabel } from "routes/reports/components/ReportLocaltimeLabel";
import { EventTrackingActions } from "store/features/event-tracking/actions";
import { ReportsViewActions } from "store/views/reports";
import { ILast7DaysReportData } from "store/views/reports/interfaces";
import { getIsReportFetching, getLast7DaysMode, getReportData } from "store/views/reports/selectors";

import { containerFluid } from "../../styled/layout";

import TicketSummary from "./TicketSummary";

const containerStyles = css`
  flex-wrap: wrap;
  justify-content: center;
  display: flex;
`;

function resolveReportsUrl(report: ReportType): string {
  return `/reports/${report}`;
}

interface IStateProps {
  isFetching: boolean;
  data: ILast7DaysReportData;
  last7DaysMode: Last7DaysMode;
}

interface IDispatchProps {
  onContentSwitcherChange(mode: Last7DaysMode): void;
  setLast7DaysFilters(resetFilters?: boolean): void;
}

interface IProps extends IStateProps, IDispatchProps {}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line react/display-name
const Last7Days: React.FC<IProps> = React.memo(({ isFetching, last7DaysMode, data, setLast7DaysFilters }) => {
  useLastVisitedReport(ReportType.Last7days);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleTicketSummaryClick = (name: ReportType) => {
    setLast7DaysFilters(true);
    trackLast7DaysSummaryReportClicked(name, last7DaysMode);
  };

  return (
    <div css={containerFluid}>
      <div css={containerStyles}>
        <TicketSummary
          isLoading={isFetching}
          data={data}
          urlResolver={resolveReportsUrl}
          onSummaryClick={handleTicketSummaryClick}
          onEmptyStateClicked={() => trackLast7DaysEmptyStateClicked(ReportType.NewTickets)}
        />
      </div>
      <ReportLocalTimeLabel />
    </div>
  );
});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = (state: any): IStateProps => ({
  isFetching: getIsReportFetching(state, ReportType.Last7days),
  // @ts-expect-error TS(2322): Type 'ILast7DaysReportData | undefined' is not ass... Remove this comment to see the full error message
  data: getReportData(state, ReportType.Last7days),
  last7DaysMode: getLast7DaysMode(state),
});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps = (dispatch: any): IDispatchProps => ({
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  onContentSwitcherChange(mode: Last7DaysMode) {
    dispatch(
      EventTrackingActions.trackEvent("Last 7 days reports content switcher clicked", EventPlace.Reports, {
        reportName: "total-chats",
        presentedData: mode,
      })
    );
  },

  setLast7DaysFilters: (resetFilters: boolean) => dispatch(ReportsViewActions.setLast7DaysFilters(resetFilters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Last7Days);
